const projectsFiltersTemplate = {
  title: "",
  createdAt: "",
  endDate: "",
  contractorUpdatedAt: "",
  drafted: false,
  completed: false,
  contractors: [],
  managers: [],
  accepted: false,
  location: "",
};

export default projectsFiltersTemplate;